export function resolveWebsiteGallery(value) {
  if (!Array.isArray(value)) return [];

  return value
    .map((item, index) => {
      if (typeof item === "string") {
        return { url: item, label: "", displayOrder: index };
      }
      return {
        ...item,
        url: item?.websiteUrl || item?.url || item?.imageUrl || "",
      };
    })
    .filter((item) => item.url)
    .sort(
      (first, second) =>
        Number(first.displayOrder ?? 0) - Number(second.displayOrder ?? 0)
    );
}

export function resolveWebsiteCatalogItem(data) {
  const images = resolveWebsiteGallery(data.images);
  return {
    ...data,
    images,
    imageUrl:
      images[0]?.url ||
      data.websiteImageUrl ||
      data.imageUrl ||
      data.image ||
      data.mainImage ||
      "",
  };
}